import { render } from "./Festivos.vue?vue&type=template&id=10999538"
import script from "./Festivos.vue?vue&type=script&lang=js"
export * from "./Festivos.vue?vue&type=script&lang=js"

import "./Festivos.vue?vue&type=style&index=0&id=10999538&lang=css"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__